import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import Vue from 'vue';
import MessageBox from 'element-ui/lib/message-box';
import 'element-ui/lib/theme-chalk/message-box.css';
import { getConfigure, fetchFile, fetchEditorShowTang, createUserRedirect } from '@kso/ui/lib/request';
import { checkType, getUA, isKaeRelease, parseUrl } from '@kso/util';
import { replaceLocHost, NOTE, getHost } from '@kso/constants';
import { WPSInvokeErr, UNCALL } from '@kso/ui/lib/config/error';
import { showError } from '@kso/ui/lib/utils';
import { call } from '@kso/ui/lib/utils/callWps';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * 调起系统的默认浏览器并打开指定的url
 *
 */
function link(_x, _x2, _x3, _x4) {
  return _link.apply(this, arguments);
}
function _link() {
  _link = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, dest, fname, ext) {
    var _parseUrl, host, _yield$createUserRedi, data, _yield$call, result, callstatus;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (/^(\/\/).+$/.test(url)) {
            url = "".concat(window.location.protocol).concat(url);
          } else if (/^(\/).+$/.test(url)) {
            url = replaceLocHost(url);
          }
          _parseUrl = parseUrl(url, 'strict'), host = _parseUrl.host; // yun core 的尝试
          _context.prev = 2;
          if (!(window.__UA__.yun && !window.__UA__.WPS && (~host.indexOf(isKaeRelease('oem') ? getHost('kdocs') : 'wps.cn') || ~host.indexOf(isKaeRelease('oem') ? getHost('kdocs') : 'kdocs.cn')))) {
            _context.next = 7;
            break;
          }
          if (!window.__UA__.isTabletClient) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", window.open(url, {
            fname: fname,
            ext: ext
          }));
        case 6:
          return _context.abrupt("return", window.open(url, '_blank'));
        case 7:
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          console.log(_context.t0);
        case 12:
          if (!(host && ~host.indexOf(isKaeRelease('oem') ? getHost('kdocs') : 'wps.cn'))) {
            _context.next = 24;
            break;
          }
          _context.prev = 13;
          _context.next = 16;
          return createUserRedirect(url);
        case 16:
          _yield$createUserRedi = _context.sent;
          data = _yield$createUserRedi.data;
          url = data.url;
          _context.next = 24;
          break;
        case 21:
          _context.prev = 21;
          _context.t1 = _context["catch"](13);
          console.log(_context.t1);
        case 24:
          if (!(window.__UA__.WPS && !(window.__UA__.wps2016 || window.__UA__.wps2018beta))) {
            _context.next = 55;
            break;
          }
          _context.prev = 25;
          _context.next = 28;
          return call({
            method: 'common.util.support',
            params: {
              api: 'openFileByCloud'
            }
          });
        case 28:
          _yield$call = _context.sent;
          result = _yield$call.result;
          callstatus = _yield$call.callstatus;
          if (!(result && callstatus === 'ok' && ~host.indexOf(isKaeRelease('oem') ? getHost('kdocs') : 'kdocs.cn'))) {
            _context.next = 37;
            break;
          }
          _context.next = 34;
          return call({
            method: 'openFileByCloud',
            openUrl: url
          });
        case 34:
          return _context.abrupt("return", _context.sent);
        case 37:
          if (!dest) {
            _context.next = 43;
            break;
          }
          _context.next = 40;
          return call({
            method: 'common.util.openInnerUrl',
            params: {
              url: url
            }
          });
        case 40:
          return _context.abrupt("return", _context.sent);
        case 43:
          _context.next = 45;
          return call({
            method: 'common.util.openUrl',
            params: {
              url: url
            }
          });
        case 45:
          return _context.abrupt("return", _context.sent);
        case 46:
          _context.next = 53;
          break;
        case 48:
          _context.prev = 48;
          _context.t2 = _context["catch"](25);
          if (!_context.t2.timeout) {
            _context.next = 52;
            break;
          }
          return _context.abrupt("return");
        case 52:
          return _context.abrupt("return", window.open(url, '_blank'));
        case 53:
          _context.next = 65;
          break;
        case 55:
          _context.prev = 55;
          _context.next = 58;
          return Promise.all([call({
            method: 'openUrl',
            url: url
          }), call({
            method: 'openUrl',
            api: 'postMessage',
            params: [url]
          })]);
        case 58:
          _context.next = 65;
          break;
        case 60:
          _context.prev = 60;
          _context.t3 = _context["catch"](55);
          if (!_context.t3.timeout) {
            _context.next = 64;
            break;
          }
          return _context.abrupt("return");
        case 64:
          return _context.abrupt("return", window.open(url, '_blank'));
        case 65:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9], [13, 21], [25, 48], [55, 60]]);
  }));
  return _link.apply(this, arguments);
}
function openWpsClient(_x5) {
  return _openWpsClient.apply(this, arguments);
}
function _openWpsClient() {
  _openWpsClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
    var fid, _ref$type, type, fileName, _ref$closeCoop, closeCoop, id, fname, fileid, groupid, storid, userid, fileInfo, _id, type1, type2, isNote, URI2, URI1, pcOfficeBrowser, currentUserId, authority, url, showPublishPanel, refirectURI, params, openByKsoQing;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          fid = _ref.fid, _ref$type = _ref.type, type = _ref$type === void 0 ? '' : _ref$type, fileName = _ref.fileName, _ref$closeCoop = _ref.closeCoop, closeCoop = _ref$closeCoop === void 0 ? false : _ref$closeCoop;
          if (!Vue.prototype.$isServer) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", Promise.reject(UNCALL));
        case 3:
          if (!fileName) {
            _context3.next = 7;
            break;
          }
          fname = fileName;
          _context3.next = 16;
          break;
        case 7:
          _context3.next = 9;
          return fetchFile(fid);
        case 9:
          fileInfo = _context3.sent;
          id = fileInfo.id;
          fname = fileInfo.fname;
          fileid = fileInfo.fileid;
          groupid = fileInfo.groupid;
          storid = fileInfo.storid;
          userid = fileInfo.userid;
        case 16:
          _id = id || fileid;
          type1 = checkType(fname, ['wdoc', 'wxls', 'wppt']); // isWdocWxlsWppt
          type2 = checkType(fname, 'h5'); // isH5
          isNote = checkType(fname, 'wpsnote');
          URI2 = replaceLocHost("/h5/".concat(_id));
          URI1 = replaceLocHost("/p/".concat(_id, "/edit"));
          pcOfficeBrowser = window && (window.cefQuery || window.wpsQuery);
          if (pcOfficeBrowser && !window.__UA__) {
            window.__UA__ = getUA(navigator.userAgent);
          } // 预览页场景无服务端渲染兼容

          // @todo 后面会交给服务端做这部分拼接的工作
          if (!isNote) {
            _context3.next = 29;
            break;
          }
          currentUserId = window.__INITIAL_STATE__.user.userid;
          authority = parseInt(userid) === currentUserId ? 'edit' : 'preview';
          url = "".concat(NOTE, "/").concat(authority, "/").concat(userid, "/").concat(storid, "?groupid=").concat(groupid, "&parentid=").concat(parent, "&entry=yunweb");
          return _context3.abrupt("return", window.open(url, JSON.stringify({
            fid: storid
          })));
        case 29:
          if (!(type2 && window.__UA__ && window.__UA__.IS_WPS_DRIVER)) {
            _context3.next = 48;
            break;
          }
          showPublishPanel = true;
          _context3.prev = 31;
          _context3.next = 34;
          return fetchEditorShowTang(fileid, {
            params: {
              fileid: fileid,
              groupid: groupid,
              share: true,
              recycle: false
            }
          });
        case 34:
          _context3.next = 39;
          break;
        case 36:
          _context3.prev = 36;
          _context3.t0 = _context3["catch"](31);
          showPublishPanel = false;
        case 39:
          _context3.prev = 39;
          _context3.next = 42;
          return call({
            method: 'gotoH5Page',
            fileid: "".concat(fileid),
            showPublishPanel: showPublishPanel
          });
        case 42:
          return _context3.abrupt("return", _context3.sent);
        case 45:
          _context3.prev = 45;
          _context3.t1 = _context3["catch"](39);
          console.log(_context3.t1);
        case 48:
          // 处理 'wdoc', 'wxls', 'wppt', 'pom', 'h5' 编辑行为
          refirectURI = type1 && URI1 || type2 && URI2;
          _context3.prev = 49;
          if (!(window.__UA__ && !window.__UA__.WPS && (type1 || type2))) {
            _context3.next = 52;
            break;
          }
          throw new Error(0, 'notRedirect');
        case 52:
          if (!refirectURI) {
            _context3.next = 54;
            break;
          }
          return _context3.abrupt("return", link(refirectURI));
        case 54:
          _context3.next = 59;
          break;
        case 56:
          _context3.prev = 56;
          _context3.t2 = _context3["catch"](49);
          return _context3.abrupt("return", Promise.reject(WPSInvokeErr({
            code: type1 && 'blank' || type2 && 'blank',
            url: refirectURI
          })));
        case 59:
          params = {
            method: 'openFile',
            fileid: fid,
            openSrc: 'myDrive',
            fileName: fname,
            isCloudFile: true,
            keepWait: true,
            type: type
          };
          _context3.prev = 60;
          _context3.next = 63;
          return call(params);
        case 63:
          _context3.next = 84;
          break;
        case 65:
          _context3.prev = 65;
          _context3.t3 = _context3["catch"](60);
          console.log('openFile error', _context3.t3);
          openByKsoQing = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var useLocalServer, _yield$getConfigure, openWpsLocalserver, _url, oldIframe, onMsg, iframe;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!window.__UA__.isWindows) {
                      _context2.next = 25;
                      break;
                    }
                    useLocalServer = false;
                    _context2.prev = 2;
                    _context2.next = 5;
                    return getConfigure({
                      params: {
                        idList: openWpsLocalserver
                      }
                    });
                  case 5:
                    _yield$getConfigure = _context2.sent;
                    openWpsLocalserver = _yield$getConfigure.data.data.openWpsLocalserver;
                    // 开关打开， === '1' 则走 local server 逻辑
                    useLocalServer = openWpsLocalserver === '1';
                    _context2.next = 13;
                    break;
                  case 10:
                    _context2.prev = 10;
                    _context2.t0 = _context2["catch"](2);
                    console.log(_context2.t0);
                  case 13:
                    if (!(useLocalServer || window.__UA__.wxpcmini || window.__UA__.isWechat)) {
                      _context2.next = 25;
                      break;
                    }
                    // windows 调用本地服务接口，如果失败则弹窗, 弹窗 -> 下载 或者调用 ksoqing 协议
                    _url = replaceLocHost("/public/openapp/wps?fileid=".concat(fid || _id, "&from=list&useLocalServer=").concat(useLocalServer));
                    oldIframe = document.getElementById('publicOpenWps');
                    onMsg = function onMsg(e) {
                      var eventName = e.data;
                      if (eventName === 'public_show_iframe') {
                        // 控制在web office中iframe显示隐藏
                        window.parent.postMessage(JSON.stringify({
                          eventName: 'web_iframe_show'
                        }), '*');
                        iframe.style.display = 'block';
                      }
                      if (eventName === 'public_hide_iframe') {
                        // 控制在web office中iframe显示隐藏
                        window.parent.postMessage(JSON.stringify({
                          eventName: 'web_iframe_hide'
                        }), '*');
                        iframe.style.display = 'none';
                      }
                    };
                    if (oldIframe) {
                      document.body.removeChild(oldIframe);
                      window.removeEventListener('message', onMsg);
                    }
                    iframe = document.createElement('iframe');
                    iframe.id = 'publicOpenWps';
                    iframe.src = _url;
                    iframe.style.cssText = 'display: none; width: 100%; height: 100%; z-index: 9999; position: fixed; border: none;top:0;';
                    document.body.appendChild(iframe);
                    window.addEventListener('message', onMsg);
                    return _context2.abrupt("return");
                  case 25:
                    window.location.href = "ksoqing://type=open&fileid=".concat(_id, "&from=clouddriver");
                  case 26:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[2, 10]]);
            }));
            return function openByKsoQing() {
              return _ref3.apply(this, arguments);
            };
          }();
          if (!closeCoop) {
            _context3.next = 82;
            break;
          }
          _context3.prev = 70;
          _context3.next = 73;
          return call(_objectSpread(_objectSpread({}, params), {}, {
            method: 'common.wpscloud.openFileWithWPS'
          }));
        case 73:
          _context3.next = 80;
          break;
        case 75:
          _context3.prev = 75;
          _context3.t4 = _context3["catch"](70);
          console.log('common.wpscloud.openFileWithWPS error', _context3.t4);
          _context3.next = 80;
          return openByKsoQing();
        case 80:
          _context3.next = 84;
          break;
        case 82:
          _context3.next = 84;
          return openByKsoQing();
        case 84:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[31, 36], [39, 45], [49, 56], [60, 65], [70, 75]]);
  }));
  return _openWpsClient.apply(this, arguments);
}
function index (_x6) {
  return _ref2.apply(this, arguments);
}
function _ref2() {
  _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(file) {
    var fileid, id, closeCoop, fileName, closeOnlineFile, fid, pcOfficeBrowser, _query;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          fileid = file.fileid, id = file.id, closeCoop = file.closeCoop, fileName = file.fileName, closeOnlineFile = file.closeOnlineFile;
          fid = fileid || id;
          _context4.prev = 2;
          // 判断仅限wps客户端内需关闭当前文档
          pcOfficeBrowser = window && (window.cefQuery || window.wpsQuery);
          _query = {
            fid: fid,
            fileName: fileName,
            closeCoop: closeCoop
          };
          if (pcOfficeBrowser && closeOnlineFile) {
            _query.type = 'web_open_client';
          }
          _context4.next = 8;
          return openWpsClient(_query);
        case 8:
          _context4.next = 13;
          break;
        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          if (_context4.t0.code === 'unsupport') {
            MessageBox.alert(_context4.t0.message, '提示');
          } else if (_context4.t0.code === 'redirect') {
            window.location.href = _context4.t0.url;
          } else if (_context4.t0.code === 'blank') {
            window.open(_context4.t0.url, '_blank');
          } else {
            showError(_context4.t0);
          }
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 10]]);
  }));
  return _ref2.apply(this, arguments);
}

export { index as default };
